import React from 'react'
import { Tooltip } from './tooltip'
import { BasicUser } from '../userSelector/users'

export enum BadgeStyle {
  light = 'bg-gray-100 text-gray-400',
  lightDarkText = 'bg-gray-100 text-gray-600',
  blue = 'bg-blue-500 text-white',
  warning = 'bg-warning text-gray-900',
  logo = 'bg-logo text-white',
  student = 'bg-gray-100 text-student',
  guardian = 'bg-gray-100 text-guardian',
  mint = 'bg-[#a8c8af] text-[#fafafa]',
  green = 'bg-green-500 text-white',
  red = 'bg-red-500 text-white',
  white = 'bg-white text-gray-900',
}

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** The content of the badge */
  children: React.ReactNode
  /** Additional class names for styling */
  className?: string
  /** The style of the badge (default is light) */
  badgeStyle?: BadgeStyle
  /** Tooltip text to show when hovering over the badge */
  tooltip?: React.ReactNode
}

/**
 * Badge component that displays a small piece of information or status, with optional tooltip support.
 */
export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ children, className, badgeStyle = BadgeStyle.light, tooltip, ...props }, ref) => {
    const badge = (
      <span
        {...props}
        ref={ref}
        className={`text-nowrap rounded px-[4.5px] py-[3px] text-xs font-bold leading-3 ${badgeStyle} ${className || ''}`}
      >
        {children}
      </span>
    )
    return tooltip ? <Tooltip text={tooltip}>{badge}</Tooltip> : badge
  }
)

export const typeToBadgeStyle = (type: BasicUser['type']): BadgeStyle =>
  type === 'teacher' ? BadgeStyle.light : type === 'student' ? BadgeStyle.student : BadgeStyle.guardian
